import Image from '@/components/general/Image/Image'
import styles from './banner.module.scss'

export default function Banner({ src, text }) {
  return (
    <>
      {
      src
        ? (
          <div className={styles.bannerWrap}>
            <Image src={src} cover width="1920" height="663" />
            <h1 className={styles.title}>{text}</h1>
          </div>
        )
        : <h1 className={styles.titleMain}>{text}</h1>
    }
    </>
  )
}
